/**
 * 播放器配置文件
 * 统一管理所有播放器相关的配置
 * 注意: 播放器URL现在从API动态获取,存储在configStore中
 */
import { useConfigStore } from '@/stores/config'

/**
 * 播放器类型枚举
 */
export enum PlayerType {
  WEB = 'web',    // PC端播放器
  H5 = 'h5'       // 移动端H5播放器
}

/**
 * 获取播放器URL
 * @param type 播放器类型,默认为WEB
 * @returns 播放器URL
 */
export function getPlayerUrl(type: PlayerType = PlayerType.WEB): string {
  const configStore = useConfigStore()

  if (type === PlayerType.H5) {
    return configStore.liveStreamUrlH5 || ''
  }

  return configStore.liveStreamUrlWeb || ''
}

/**
 * 获取Web播放器URL(PC端)
 */
export function getWebPlayerUrl(): string {
  return getPlayerUrl(PlayerType.WEB)
}

/**
 * 获取H5播放器URL(移动端)
 */
export function getH5PlayerUrl(): string {
  return getPlayerUrl(PlayerType.H5)
}

/**
 * 导出配置对象(兼容旧的使用方式)
 */
export default {
  PlayerType,
  getPlayerUrl,
  getWebPlayerUrl,
  getH5PlayerUrl
}

